export { default } from './FaqItemToggle';
